import { createAction, props } from "@ngrx/store";
import { FeatureFlagValue } from "src/backend/gateway-api/types";

export const loadFeatureFlags = createAction("[Feature Flags] Load");

export const loadFeatureFlagsSuccess = createAction(
  "[Feature Flags] Load Success",
  props<{ featureFlags: FeatureFlagValue[] }>()
);

export const loadFeatureFlagsFailure = createAction(
  "[Feature Flags] Load Failure",
  props<{ error: any }>()
);
